module.exports = __webpack_public_path__ + "fonts/0181c94c3da67d5a04b650a3723d0007.woff";